import * as ActionCreator from "utilities/action.creator";

export const MODULE = "Auth";

export const $reset = ActionCreator.Default(MODULE, "reset", () =>
  $reset.action()
);

export const $setSession = ActionCreator.Default(
  MODULE,
  "setSession",
  (session) => $setSession.action({ session })
);
